enum EducationLevel {
  highSchool = "Lise",
  associate = "Ön Lisans",
  bachelor = "Lisans",
  master = "Yüksek Lisans",
  doctoral = "Doktora",
}

export default EducationLevel;
